import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWand16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconWand16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m12.437 2.149-1.803 1.803 1.414 1.414 1.803-1.803zM2.255 12.33l7.672-7.67 1.414 1.415-7.672 7.671zm-.707-.707a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0L14.558 4.27a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0zM4.503 2.21a.5.5 0 0 1 .5.5v1.292h1.293a.5.5 0 0 1 0 1H5.003v1.294a.5.5 0 0 1-1 0V5.002H2.71a.5.5 0 1 1 0-1h1.293V2.71a.5.5 0 0 1 .5-.5m5.001 8.909a.5.5 0 0 1 .5.5v.38h.372a.5.5 0 1 1 0 1h-.371v.363a.5.5 0 0 1-1 0v-.364h-.372a.5.5 0 0 1 0-1h.371v-.38a.5.5 0 0 1 .5-.5m3.498-2.925a.5.5 0 0 0-1 0v.809h-.808a.5.5 0 0 0 0 1h.808v.806a.5.5 0 1 0 1 0v-.806h.808a.5.5 0 1 0 0-1h-.808z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWand16);
